var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "search-form js-search-form",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.raiseSubmit($event)
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "input-group" },
        [
          _c(
            "label",
            { staticClass: "sr-only", attrs: { for: "header-search" } },
            [_vm._v("Search")]
          ),
          _vm._v(" "),
          _c("typeahead", {
            attrs: {
              options: _vm.options,
              "current-search-term": _vm.searchQuery
            },
            on: {
              "update-search": _vm.searchNew,
              "update-typeahead": _vm.getTypeaheadItems
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }